import React from 'react';
import {
    Box,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    useTheme,
    alpha
} from '@mui/material';

const AccountTypeSelector = ({ value, onChange }) => {
    const theme = useTheme();

    return (
        <Box>
            <Typography variant="subtitle2" sx={{
                mb: 2,
                color: theme.palette.text.secondary,
                fontWeight: 600
            }}>
                Account Type
            </Typography>
            <FormControl>
                <RadioGroup
                    row
                    name="account_type"
                    value={value}
                    onChange={onChange}
                    sx={{ gap: 2 }}
                >
                    <FormControlLabel
                        value="SAVINGS"
                        control={<Radio sx={{ '&.Mui-checked': { color: theme.palette.primary.main } }} />}
                        label={
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                py: 1,
                                px: 2,
                                borderRadius: 2,
                                border: `1px solid ${value === 'SAVINGS' ? theme.palette.primary.main : theme.palette.divider}`,
                                bgcolor: value === 'SAVINGS' ? alpha(theme.palette.primary.main, 0.1) : 'transparent'
                            }}>
                                <Typography sx={{ fontWeight: 500 }}>Savings Account</Typography>
                            </Box>
                        }
                    />
                    <FormControlLabel
                        value="CURRENT"
                        control={<Radio sx={{ '&.Mui-checked': { color: theme.palette.primary.main } }} />}
                        label={
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                py: 1,
                                px: 2,
                                borderRadius: 2,
                                border: `1px solid ${value === 'CURRENT' ? theme.palette.primary.main : theme.palette.divider}`,
                                bgcolor: value === 'CURRENT' ? alpha(theme.palette.primary.main, 0.1) : 'transparent'
                            }}>
                                <Typography sx={{ fontWeight: 500 }}>Current Account</Typography>
                            </Box>
                        }
                    />
                </RadioGroup>
            </FormControl>
        </Box>
    );
};

export default AccountTypeSelector;
